import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  teamPaymentCollectionSchema,
  teamPaymentCollectionListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/teamPaymentCollections/actions';
import { getTeamPaymentRequest } from 'app/ducks/teamPaymentRequests/actions';
import { getPaymentEvent } from 'app/ducks/paymentEvents/actions';
import { getCompetition } from 'app/ducks/competitions/actions';
import { TeamPaymentCollectionsActionTypes as types } from 'app/ducks/teamPaymentCollections/types';

function* createTeamPaymentCollectionSaga(action): any {
  yield put(sagaActions.createTeamPaymentCollectionPending(action.payload));
  const [error, response] = yield (yield (yield TeammoApi(yield select()))).teamPaymentCollections.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, teamPaymentCollectionSchema);

    yield put(sagaActions.createTeamPaymentCollectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createTeamPaymentCollectionFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateTeamPaymentCollectionSaga(action): any {
  yield put(sagaActions.updateTeamPaymentCollectionPending(action.payload.data));
  // console.log(action.payload.data);
  const [error, response] = yield (yield (yield TeammoApi(yield select(), undefined, undefined, true))).teamPaymentCollections.update(action.payload.data);

  if (response) {
    const normalizedResponse = normalize(response, teamPaymentCollectionSchema);
    const pc = normalizedResponse.entities.teamPaymentCollections[
      normalizedResponse.result
    ];

    if (!_.isEmpty(pc.paymentRequest?.id)) {
      yield put(yield getTeamPaymentRequest(pc.paymentRequest.id));
    }
    if (action.payload.callbackFunction !== undefined) {
      action.payload.callbackFunction();
    }

    yield put(sagaActions.updateTeamPaymentCollectionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateTeamPaymentCollectionFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getTeamPaymentCollectionSaga(action): any {
  yield put(sagaActions.getTeamPaymentCollectionPending());
  const [error, response] = yield (yield (yield TeammoApi(yield select()))).teamPaymentCollections.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response);
    yield put(sagaActions.getTeamPaymentCollectionSuccess(normalizedResponse));
    const pc = normalizedResponse.entities.teamPaymentCollections[normalizedResponse.result];

    if (!_.isEmpty(pc.fixtureMatch.id)) {
      yield put(yield getPaymentEvent(pc.fixtureMatch.id));
    }

    if (!_.isEmpty(pc.competition?.id)) {
      yield put(yield getCompetition(pc.competition.id));
    }
    return pc;
  }
  yield put(
    handleError(
      error,
      sagaActions.getTeamPaymentCollectionFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* getAllTeamPaymentCollectionsSaga(action): any {
  yield put(
    sagaActions.getAllTeamPaymentCollectionsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.teamPaymentCollections.pagination),
    )
    : action.payload.pagination;

  // const [error, response] = yield (yield (yield TeammoApi(yield select(), null, null, false, true))).teamPaymentCollections.list(paginationObject);
  let teammoApi = TeammoApi(yield select());

  if (action.payload.teamMemberView) {
    teammoApi = TeammoApi(yield select(), null, null, false, false, {
      'team-member-code': action.payload.teamMemberCode,
      'team-code': action.payload.teamCode,
    });
  }
  const [error, response] = yield (yield (yield teammoApi)).teamPaymentCollections.list(paginationObject);

  if (response) {
    // const deserializedResponse = deserialize(response, {
    //   transformKeys: 'camelCase',
    // });
    // console.log(deserializedResponse);
    const normalizedResponse = normalize(
      response,
      teamPaymentCollectionListSchema,
    );
    // console.log(normalizedResponse);

    yield put(
      sagaActions.getAllTeamPaymentCollectionsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllTeamPaymentCollectionsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createTeamPaymentCollectionSagaWatcher(): any {
  yield takeEvery(
    types.CREATE_TEAM_PAYMENT_COLLECTION_REQUESTED,
    createTeamPaymentCollectionSaga,
  );
}

function* updateTeamPaymentCollectionSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_TEAM_PAYMENT_COLLECTION_REQUESTED,
    updateTeamPaymentCollectionSaga,
  );
}

function* getTeamPaymentCollectionSagaWatcher(): any {
  yield takeLatest(
    types.GET_TEAM_PAYMENT_COLLECTION_REQUESTED,
    getTeamPaymentCollectionSaga,
  );
}

function* getAllTeamPaymentCollectionsSagaWatcher(): any {
  yield takeEvery(
    types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_REQUESTED,
    getAllTeamPaymentCollectionsSaga,
  );
}

export default function* root(): any {
  yield all([
    createTeamPaymentCollectionSagaWatcher(),
    updateTeamPaymentCollectionSagaWatcher(),
    getTeamPaymentCollectionSagaWatcher(),
    getAllTeamPaymentCollectionsSagaWatcher(),
  ]);
}
